import React, {
  FunctionComponent,
  useRef,
  useState,
  Children,
  useEffect,
  ReactNode,
} from "react";
import { useLayoutEffect } from "react";
import useDevice from "../../utils/hooks/useDevice";

const RightArrow: FunctionComponent = ({}) => (
  <svg width={16} height={30} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m1 28.877 13.21-13.21a1 1 0 0 0 0-1.415L1 1.04"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const RightArrow2: FunctionComponent = ({}) => (
  <svg width={22} height={19} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12.313 1.386 8.018 8.019a.3.3 0 0 1 0 .424l-8.018 8.019M19.975 9.57H1.78"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const LeftArrow: FunctionComponent = ({}) => (
  <svg width={16} height={30} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="m14.918 1.041-13.21 13.21a1 1 0 0 0 0 1.415l13.21 13.211"
      stroke="#fff"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

const LeftArrow2: FunctionComponent = ({}) => (
  <svg width={22} height={19} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.582 17.85 1.563 9.83a.3.3 0 0 1 0-.424l8.019-8.02M1.92 9.666h18.193"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

export const HorizontalScroll: FunctionComponent<{
  scrollBy: number;
  items?: number;
  size?: number;
  children: ReactNode;
  catalogScroll?: boolean;
  paddingInBtns?: boolean;
  isHero?: boolean;
}> = ({
  children,
  scrollBy,
  items,
  size,
  catalogScroll,
  paddingInBtns,
  isHero,
}) => {
  const ref = useRef(null);
  const { isMobile } = useDevice();
  const refDiv = useRef<HTMLDivElement>(null);
  const [touchPosition, setTouchPosition] = useState(null);
  const [width, setWidth] = useState(0);
  useLayoutEffect(() => {
    setWidth(refDiv.current?.clientWidth as any);
  }, []);
  const [porcentage, setPorcentage] = useState<number>(0);
  const [scrolledLeft, setScrolledLeft] = useState<number>(0);
  const [scrolledRight, setScrolledRight] = useState<number>(0);
  const [clickScroll, setClickScroll] = useState<number>(0);
  const childrenCount = Children.count(children);

  const autoScroll = () => {
    isHero &&
      setTimeout(() => {
        items && clickScroll < items - 1
          ? handleScroll("right")
          : setClickScroll(0);
      }, 5000);
  };

  useEffect(() => {
    isHero && autoScroll();
    updateScroll();
  }, [clickScroll]);

  useEffect(() => {
    autoScroll();
  }, []);

  useEffect(() => {
    if (items && size) {
      if (items * size - width < 0) {
        setPorcentage(100);
      } else {
        setPorcentage((scrolledRight * 100) / (items * size - width));
      }
    }
  }, [scrolledLeft, scrolledRight]);

  const updateScroll = () => {
    if (ref && ref.current && ref.current) {
      (ref.current as any).scrollLeft = clickScroll * scrollBy;
      setScrolledRight(clickScroll * scrollBy);
      setScrolledLeft(clickScroll * scrollBy * -1);
    }
  };
  const handleScroll = (mode: "right" | "left") => {
    if (mode === "right") {
      setClickScroll(clickScroll + 1);
    } else {
      setClickScroll(clickScroll - 1);
    }
  };

  const containerStyles = {
    height: 3,
    width: "80%",
    backgroundColor: "transparent",
    borderRadius: 50,
    alignSelf: "center",
  };

  const fillerStyles = {
    height: "100%",
    width: `${porcentage}%`,
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderRadius: "inherit",
    transition: "width 1s ease-in-out",
  };

  return (
    <section className="scroll_container" ref={refDiv}>
      {scrolledLeft != 0 ? (
        <button
          className={`scroll_button button_left  ${
            catalogScroll && `button_hide`
          }`}
          onClick={() => handleScroll("left")}
        >
          <LeftArrow />
        </button>
      ) : null}
      <main
        ref={ref}
        className={`scroll_main ${isHero ? `scroll_padding` : null}`}
      >
        {children}
      </main>
      <div className="controls_container">
        {!isHero && (
          <div className="scroll_bar" style={containerStyles}>
            <div style={fillerStyles}>
              <span></span>
            </div>
          </div>
        )}
        {(items && items > 0 && (items - 1) * scrollBy === scrolledRight) ||
        (items &&
          childrenCount != 1 &&
          items > 0 &&
          childrenCount <= items - 1) ||
        (childrenCount > 1 && size
          ? childrenCount * size <= width + scrolledRight
          : null) ||
        (items && size
          ? items * size <= width + scrolledRight
          : null) ? null : (
          <button
            className={`scroll_button button_right ${
              catalogScroll && `button_hide`
            }`}
            onClick={() => handleScroll("right")}
          >
            <RightArrow />
          </button>
        )}
        {catalogScroll && (
          <div className={`scroll_buttons ${paddingInBtns && `paddingInBtns`}`}>
            {scrolledLeft < 0 ? (
              <button onClick={() => handleScroll("left")}>
                <LeftArrow2 />
              </button>
            ) : (
              <button disabled={true}>
                <LeftArrow2 />
              </button>
            )}
            {(items && items > 0 && (items - 1) * scrollBy === scrolledRight) ||
            (items &&
              childrenCount != 1 &&
              items > 0 &&
              childrenCount <= items - 1) ||
            (childrenCount > 1 && size
              ? childrenCount * size <= width + scrolledRight
              : null) ||
            (items && size ? items * size <= width + scrolledRight : null) ? (
              <button disabled={true}>
                <RightArrow2 />
              </button>
            ) : (
              <button onClick={() => handleScroll("right")}>
                <RightArrow2 />
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
